import React, { useEffect, useState } from 'react';
import { IAddBuildingProps } from './IAddBuildingprops';
import LabelledInput from '../LabelledInput';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';
import Dropzone from 'react-dropzone';
import './_addbuilding.css';
import { ApiHandler } from '../../services/apiHandler';
import Spinner from '../Spinner';
import ConfirmAlert from '../confirmAlert';
import ErrorAlert from '../ErrorAlert';
import SuccessAlert from '../SuccessAlert';
import WarningAlert from '../WarningAlert';
import { useNavigate } from 'react-router-dom';
import {
  CloseOutlined,
  DeleteTwoTone,
  DeploymentUnitOutlined,
  DownloadOutlined,
  DownOutlined,
  FileImageOutlined,
  GlobalOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { Dropdown, MenuProps, Select, UploadProps, Upload } from 'antd';
import { Building } from '../../custom_icons/Building';
import { PenIcon } from '../../custom_icons/PenTool';
import LabelLessInput from '../LabelLessInput';
import LabelledInputNew from '../LabelledInputNew';
import { VenueDrawPlot } from '../VenueDrawPlot/VenueDrawPlot';
import ImageResizer from 'react-image-file-resizer';
import Dragger from 'antd/es/upload/Dragger';

export const AddBuilding: React.FC<IAddBuildingProps> = (props) => {
  let navigate = useNavigate();
  const [confirmAlert, setConfirmAlert] = useState({ alert: false, message: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: '',
    alert: false,
  });
  const [warning, setWarning] = useState({
    message: '',
    alert: false,
  });
  const [success, setSuccess] = useState({
    message: '',
    alert: false,
  });
  const [building, setBuilding] = useState({
    name: '',
    description: '',
    address: '',
    country: '',
    state: '',
    city: '',
    zipcode: '',
    latitude: 0,
    longitude: 0,
    image: undefined,
    total_floors: 0,
    floors_in_use: 0,
    height: 0,
    height_unit: 'm',
    elevation: 0,
    elevation_unit: 'm',
  });
  const [venue, setVenue] = useState<any>();
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [isDrawActive, setIsDrawActive] = useState(false);
  const [isCreateActive, setIsCreateActive] = useState(false);
  const [assetsInBuilding, setAssetsInBuilding] = useState<any[]>([]);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [boundaryConfirmed, setBoundaryConfirmed] = useState(false);

  useEffect(() => {
    if (isCreateActive) {
      checkAssetsInBuilding();
    }
  }, [props.assetsInBounds]);

  useEffect(() => {
    setBuilding((prevValues: any) => {
      return {
        ...prevValues,
        latitude: parseFloat(props.position.lat.toFixed(6)),
        longitude: parseFloat(props.position.lng.toFixed(6)),
      };
    });
  }, [props.position]);

  useEffect(() => {
    if (venue !== undefined) {
      checkLocationInPolygon();
    }
    if (props?.position) reverseGeoCodeAddress();
  }, [props.position]);

  useEffect(() => {
    if (props.venueId) getVenue();
  }, [props.venueId]);

  const checkAssetsInBuilding = () => {
    if (props.assetsInBounds.length > 0) {
      let assetsInBuildingList: any[] = [];
      for (let asset of props.assetsInBounds) {
        const contains: any = window.google.maps.geometry.poly.containsLocation(
          new window.google.maps.LatLng(asset.latitude, asset.longitude),
          new window.google.maps.Polygon({ paths: props.boundaryPolygon })
        );
        if (contains) {
          assetsInBuildingList.push(asset);
        }
      }
      setAssetsInBuilding(assetsInBuildingList);
      if (assetsInBuildingList.length > 0) {
        let confirmMessage: string = '<b>Assets with following Site IDs fall inside the bounds of Building.</b><br/><br/><ul>';
        assetsInBuildingList.forEach((asset: any) => {
          confirmMessage += '<li>' + asset.tracking_id + '</li>';
        });
        confirmMessage +=
          '</ul><i>On confirming the creation, the assets will <b>automatically be associated to the Building</b>.</i><br/><br/><span>Do you want to proceed?</span>';
        setConfirmAlert({ alert: true, message: confirmMessage });
      }
    }
    setIsCreateActive(false);
  };

  const checkLocationInPolygon = () => {
    const contains: any = window.google.maps.geometry.poly.containsLocation(
      new window.google.maps.LatLng(props.position.lat, props.position.lng),
      new window.google.maps.Polygon({ paths: venue?.polygon_points })
    );
    if (!contains) {
      setIsSaveDisabled(true);
      setWarning({
        message: 'Please select a location within the venue',
        alert: true,
      });
    } else {
      setIsSaveDisabled(false);
      setBuilding((prevValues: any) => {
        return {
          ...prevValues,
          latitude: parseFloat(props.position.lat.toFixed(6)),
          longitude: parseFloat(props.position.lng.toFixed(6)),
        };
      });
    }
  };

  const getVenue = () => {
    setLoading(true);
    ApiHandler({ apiName: 'getVenue', body: {}, params: { venue_id: props.venueId } })
      .then((res: any) => {
        setLoading(false);
        setVenue(res.data);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error?.data?.message, alert: true });
        }
      });
  };

  const handleInputChange = (e: any) => {
    setBuilding((prevValues: any) => {
      return { ...prevValues, [e.target.name]: e.target.value };
    });
  };

  const setBoundaryPolygonToCreatBuilding = () => {
    // set boundary plot from google.maps.LatLng to {lat: number, lng: number}
    let boundary = props.boundaryPolygon?.map((point) => {
      return {
        lat: parseFloat(point.lat().toFixed(6)),
        lng: parseFloat(point.lng().toFixed(6)),
      };
    });
    // push first vertex as last vertex to make it a closed polygon
    boundary?.push(boundary[0]);
    return boundary;
  };

  const validateRequest = () => {
    if (building.name.trim() === '' || !building.name) {
      setWarning({ message: 'Building name is required', alert: true });
      return false;
      // } else if (/[^a-zA-Z\s]/.test(building.name)) {
      //   setWarning({ message: 'Building name cannot contain numbers or special characters', alert: true });
      //   return false;
    } else if (Number(building?.total_floors) < 0) {
      setWarning({ message: 'Please enter a valid number of floors.', alert: true });
      return false;
    } else if (Number(building?.floors_in_use) < 0) {
      setWarning({ message: 'Please enter a valid number of floors in use.', alert: true });
      return false;
    } else if (Number(building?.floors_in_use) > Number(building?.total_floors)) {
      setWarning({ message: 'Floors in use cannot be greater than total floors.', alert: true });
      return false;
    } else if (Number(building.height) < 0) {
      setWarning({ message: 'Please enter a valid building height.', alert: true });
      return false;
    } else if (Number(building.elevation) < 0) {
      setWarning({ message: 'Please enter a valid elevation.', alert: true });
      return false;
    }
    return true;
  };

  const createBuilding = () => {
    if (!validateRequest()) return;
    setLoading(true);
    let boundary = setBoundaryPolygonToCreatBuilding();
    let formData = new FormData();
    if (props.venueId) {
      formData.append('venue_id', props.venueId);
    }
    formData.append('name', building.name);
    formData.append('description', building.description);
    formData.append('address', building.address);
    formData.append('latitude', building.latitude.toString());
    formData.append('longitude', building.longitude.toString());
    formData.append('total_floors', building.total_floors.toString());
    formData.append('country', building.country);
    formData.append('state', building.state);
    formData.append('address', building.address);
    formData.append('city', building.city);
    formData.append('zip_code', building.zipcode);
    if (boundary) formData.append('boundary_plot', JSON.stringify(boundary));
    if (building.image !== undefined) {
      formData.append('image', building.image);
    }
    ApiHandler({ apiName: 'createBuilding', body: formData, params: {} })
      .then((res: any) => {
        setLoading(false);
        setSuccess({
          message: 'Building Added Successfully',
          alert: true,
        });
        props.cancelBoundaryDraw();
        if (props.venueId) {
          setTimeout(() => {
            props.navigateTo('venueDetails');
          }, 1000);
        } else {
          console.log('navigating to building details');
          props.setBuildingId(res.data?.building_id);
          props.navigateTo('home');
          // setTimeout(() => {
          //   props.navigateTo('buildingDetails');
          // }, 1000);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const items: MenuProps['items'] = [
    {
      key: 'venue',
      label: 'Venue',
      icon: <GlobalOutlined />,
    },
    {
      key: 'market',
      label: 'Market',
      icon: <DeploymentUnitOutlined />,
    },
    {
      key: 'building',
      label: 'Building',
      icon: <Building />,
    },
  ];

  const heightUnitOptions = [
    {
      lable: 'm',
      value: 'm',
    },
    {
      lable: 'ft',
      value: 'ft',
    },
  ];

  const drawBoundary = () => {
    setIsDrawActive(true);
    props.setBoundaryDrawMode('draw');
  };

  const confirmBoundary = () => {
    // const inside = google.maps.geometry.poly.containsLocation(
    //   new google.maps.LatLng(props.position.lat, props.position.lng),
    //   new google.maps.Polygon({ paths: props.boundaryPolygon })
    // );
    // if (!inside) {
    //   setWarning({
    //     message: 'Please select a location within the boundary polygon',
    //     alert: true,
    //   });
    //   return;
    // }
    if (typeof props.boundaryPolygon == 'undefined' || props.boundaryPolygon.length === 0) {
      setWarning({
        message: "Boundary of the Building is not defined yet. Click on the 'Draw Boundaries' button to start.",
        alert: true,
      });
      return;
    }
    setBoundaryConfirmed(true);
    setIsDrawActive(false);
    props.setBoundaryDrawMode(null);
  };

  const cancelBoundary = () => {
    setIsDrawActive(false);
    props.cancelBoundaryDraw();
  };

  const startBuildingVenue = () => {
    if (typeof props.boundaryPolygon == 'undefined' || props.boundaryPolygon.length === 0) {
      setWarning({
        message: "Boundary of the Building is not defined yet. Click on the 'Draw Boundaries' button to start.",
        alert: true,
      });
      return;
    }
    if (!boundaryConfirmed) {
      setWarning({
        message: 'Please confirm the building boundary before creating the building.',
        alert: true,
      });
      return;
    }
    const closed = [...props.boundaryPolygon, props.boundaryPolygon[0]];

    const inside = google.maps.geometry.poly.containsLocation(
      new google.maps.LatLng(props.position.lat, props.position.lng),
      new google.maps.Polygon({ paths: closed })
    );
    console.log(closed, 'boundary poly', inside, props.position.lat, props.position.lng);

    if (!inside) {
      setWarning({
        message: 'Please select a location within the boundary polygon',
        alert: true,
      });
      return;
    }
    setIsCreateActive(true);
    setConfirmAlert({ alert: true, message: 'Are you sure you want to finalize the building creation?' });
    props.fitVenueOnMap();
  };

  const propsDragger: UploadProps = {
    name: 'file',
    multiple: false,
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    accept: 'image/png, image/jpeg',

    beforeUpload: (file) => {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isImage) {
        setWarning({ message: 'You can only upload JPG/PNG file!', alert: true });
        return Upload.LIST_IGNORE;
      }

      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        setWarning({ message: 'Image must be smaller than 4MB!', alert: true });
        return Upload.LIST_IGNORE;
      }

      console.log('Uploading and resizing image');
      ImageResizer.imageFileResizer(
        file,
        800,
        800,
        'JPEG',
        100,
        0,
        (uri: any) => {
          setImageUploaded(true);
          setBuilding((prevValues: any) => {
            return { ...prevValues, ['image']: uri };
          });
          // uploadImageApi('', file, uri);
        },
        'base64'
      );

      return false;
    },
  };

  const reverseGeoCodeAddress = () => {
    setLoading(true);
    ApiHandler({ apiName: 'getAddress', body: {}, params: {}, queryParams: { latitude: props.position.lat, longitude: props.position.lng } })
      .then((res: any) => {
        setLoading(false);
        if (res?.data?.address)
          setBuilding((prevValues: any) => {
            return { ...prevValues, ['address']: res.data.address };
          });
        if (res?.data?.country)
          setBuilding((prevValues: any) => {
            return { ...prevValues, ['country']: res.data.country };
          });
        if (res?.data?.state)
          setBuilding((prevValues: any) => {
            return { ...prevValues, ['state']: res.data.state };
          });
        if (res?.data?.city)
          setBuilding((prevValues: any) => {
            return { ...prevValues, ['city']: res.data.city };
          });
        if (res?.data?.zipcode)
          setBuilding((prevValues: any) => {
            return { ...prevValues, ['zipcode']: res.data.zipcode };
          });
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  return (
    <div className="h-100 row-wise overflow-auto">
      <div className="right row-wise ">
        {/* Plot Boundary */}
        {isDrawActive && <VenueDrawPlot setColor={() => {}} color={''} />}

        <div className="app-card app-card-size ">
          {/* <div className="row-wise vertical-center">
          <div
            className="icon-background-active"
            onClick={() => {
              props.navigateTo("venueDetails");
            }}
          >
            <span className="material-icons-round icon-active">arrow_back</span>
          </div>

          <span className="app-card-action-heading ms-3">ADDING BUILDING</span>
           </div> */}
          <div className="row-wise vertical-center space-between px-4 py-2">
            <span className="app-card-action-heading fw-bold">New Building</span>
            <div
              onClick={() => {
                console.log(props.navigateFrom, 'navigatefrom');
                cancelBoundary();
                props.navigateTo(props.navigateFrom);
              }}>
              <CloseOutlined className="fs-6 cursor-pointer" />
            </div>
          </div>
          <div className="border-bottom" />
          <div className="overflow-auto">
            <div className="px-4 ">
              {/* <div className="pt-2">
                <Dropdown className="w-100 " disabled menu={{ items }} trigger={['click']}>
                  <div className="border row-wise space-between vertical-center background-white" onClick={(e) => e.preventDefault()}>
                    <span>
                      {' '}
                      <Building /> &nbsp; Building{' '}
                    </span>
                    <DownOutlined />
                  </div>
                </Dropdown>
              </div> */}

              {imageUploaded ? (
                <div className="vertical-center center my-3 position-relative">
                  <DeleteTwoTone
                    className="position-absolute z-index-10"
                    onClick={() => {
                      const buildingTemp = building;
                      buildingTemp['image'] = undefined;
                      setBuilding(buildingTemp);
                      setImageUploaded(false);
                    }}
                  />
                  <img src={building.image} height={'auto'} width={350 - 48} />
                </div>
              ) : (
                <div className="drop-height">
                  <Dragger {...propsDragger}>
                    <p className="ant-upload-drag-icon">
                      <FileImageOutlined />
                    </p>
                    <p className="ant-upload-textupload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint upload-text-sub">Pick a photo up to 4MB.</p>
                  </Dragger>
                </div>
              )}
            </div>
            <div className="border-bottom mx-4" />
            <div className="px-4 py-2">
              <div className="fw-semibold small text-muted mb-2">Building Boundaries</div>
              <div>
                {isDrawActive ? (
                  <div className="row ">
                    <div className="col-6">
                      <SecondaryButton className="my-1 h-btn-lg" label={'Confirm Boundary'} clicked={confirmBoundary} disable={false} />
                    </div>
                    <div className="col-6">
                      <SecondaryButton className="my-1 h-btn-lg" label={'Cancel'} clicked={cancelBoundary} disable={false} type="delete" />
                    </div>
                  </div>
                ) : (
                  <div className="w-100">
                    <SecondaryButton
                      className="mb-2 mt-2"
                      label={'Draw boundaries'}
                      clicked={drawBoundary}
                      disable={false}
                      icon={<PenIcon style={{ color: '#1677FF' }} />}
                    />
                  </div>
                )}
              </div>

              <form className="col-wise h-100 pb-1 mb-1 pt-2">
                <LabelledInputNew
                  title="Name *"
                  name="name"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={building.name}
                  placeholder="Enter name"
                  titleClassName="fw-semibold small text-muted"
                  textColorRequired={false}
                />
                <div className="row gx-2">
                  <div className="col-6">
                    <LabelledInputNew
                      title="Total Floors"
                      name="total_floors"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      type="number"
                      value={building.total_floors}
                      placeholder="Enter total floors"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                  <div className="col-6">
                    <LabelledInputNew
                      title="Floors in Use"
                      name="floors_in_use"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      type="number"
                      value={building.floors_in_use}
                      placeholder="Enter floors in use"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                </div>
                <div className="mb-2">
                  <span className="d-block mb-2 fw-semibold small text-muted">Building Height (optional)</span>
                  <div className="d-flex gap-2">
                    <LabelLessInput
                      name="height"
                      changeVal={(e: any) => {
                        handleInputChange(e);
                      }}
                      type="number"
                      value={building.height}
                      placeholder="Specify Height"
                      w100
                    />
                    <Select
                      className="flex-grow-1"
                      options={heightUnitOptions}
                      value={building.height_unit}
                      onChange={(e) => {
                        setBuilding((prevValues: any) => {
                          return { ...prevValues, ['height_unit']: e };
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-2">
                  <span className="d-block mb-2 fw-semibold small text-muted">
                    Elevation <QuestionCircleOutlined className="text-muted" />
                  </span>
                  <div className="d-flex gap-2">
                    <LabelLessInput
                      name="elevation"
                      changeVal={(e: any) => {
                        handleInputChange(e);
                      }}
                      type="number"
                      value={building.elevation}
                      placeholder="Specify Elevation"
                      w100
                    />
                    <Select
                      className="flex-grow-1"
                      options={heightUnitOptions}
                      value={building.elevation_unit}
                      onChange={(e) => {
                        setBuilding((prevValues: any) => {
                          return { ...prevValues, ['elevation_unit']: e };
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="row g-2 mb-3 mt-2">
                  <div className="col-6">
                    <div className="rounded p-2" style={{ backgroundColor: '#e4f1f4' }}>
                      <span className="d-block mb-1 fw-semibold small text-muted">Latitude</span>
                      <span className="d-block fw-bold text-dark">{building.latitude.toFixed(6)}</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rounded p-2" style={{ backgroundColor: '#e4f1f4' }}>
                      <span className="d-block mb-1 fw-semibold small text-muted">Longitude</span>
                      <span className="d-block fw-bold text-dark">{building.longitude.toFixed(6)}</span>
                    </div>
                  </div>
                </div>
                <LabelledInputNew
                  title="Street Address"
                  name="address"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={building.address}
                  placeholder="Enter Street Address"
                  titleClassName="fw-semibold small text-muted"
                  textColorRequired={false}
                />

                <div className="row gx-2">
                  <div className="col-6">
                    <LabelledInputNew
                      title="City"
                      name="city"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={building.city}
                      placeholder="Enter City"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                  <div className="col-6">
                    <LabelledInputNew
                      title="State"
                      name="state"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={building.state}
                      placeholder="Enter State"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                </div>

                <div className="row gx-2">
                  <div className="col-6">
                    <LabelledInputNew
                      title="Country"
                      name="country"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={building.country}
                      placeholder="Enter Country"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                  <div className="col-6">
                    <LabelledInputNew
                      title="Zip Code"
                      name="zipcode"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={building.zipcode}
                      placeholder="Enter ZIP"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                </div>
              </form>
            </div>

            {/* <form className="overflow-auto col-wise h-100 pe-3 ps-1 pb-1 mb-1 pt-2">
            <LabelledInput
              title="Name*"
              name="name"
              onChange={(e: any) => {
                handleInputChange(e);
              }}
              value={building.name}
            />
            <LabelledInput
              title="Total Number of Floors*"
              name="total_floors"
              onChange={(e: any) => {
                handleInputChange(e);
              }}
              type="number"
              value={building.total_floors}
            />
            <div className="form-floating w-100 mb-2">
              <textarea
                rows={5}
                id="description"
                className="form-control textbox-box input-text h-auto"
                placeholder={"Description"}
                name="description"
                onChange={(e: any) => {
                  handleInputChange(e);
                }}
                value={building.description}
              ></textarea>
              <label className="input-label" htmlFor="description">
                Description
              </label>
            </div>
                  */}
            {/* Image Upload */}
            {/*    <Dropzone
              multiple={false}
              onDrop={(acceptedFiles: any) => {
                setBuilding((prevValues: any) => {
                  return { ...prevValues, image: acceptedFiles[0] };
                });
                console.log(acceptedFiles[0]);
              }}
              accept={{ "image/jpg": [".jpg"], "image/jpeg": [".jpeg"], "image/png": [".png"] }}
            >
              {({ getRootProps, getInputProps }) => (
                <section className="img-dropzone-set mb-2">
                  <div
                    {...getRootProps({
                      className: `${building.image !== undefined ? "img-building-uploaded" : "img-building"}`,
                    })}
                  >
                    <input {...getInputProps()} />

                    {building.image === undefined ? (
                      <div className="row-wise vertical-center ps-2 w-100 h-100">
                        <span className="material-icons-outlined">add_a_photo</span>
                        <span className="ps-2">Upload Building Image</span>
                      </div>
                    ) : (
                      <div className="row-wise vertical-center ps-2 w-100 h-100">
                        <span className="material-icons-outlined">photo_camera</span>
                        <span className="ps-2">{building.image["name"]}</span>
                      </div>
                    )}
                  </div>
                  <div></div>
                </section>
              )}
            </Dropzone>

            <div className="form-floating w-100 mb-2">
              <textarea
                rows={5}
                id="address"
                className="form-control textbox-box input-text h-auto"
                placeholder={"Address"}
                name="address"
                onChange={(e: any) => {
                  handleInputChange(e);
                }}
                value={building.address}
              ></textarea>
              <label className="input-label" htmlFor="address">
                Address*
              </label>
            </div>

            <div className="row gx-2">
              <div className="col-6">
                <LabelledInput title="Latitude*" name="latitude" disabled value={building.latitude} />
              </div>
              <div className="col-6">
                <LabelledInput title="Longitude*" name="longitude" disabled value={building.longitude} />
              </div>
            </div>
          </form> */}
          </div>

          <div style={{ marginTop: 'auto' }} className="row-wise vertical-center px-4 py-2 gap-3">
            <SecondaryButton
              className=" w-100"
              label={'Cancel'}
              clicked={() => {
                cancelBoundary();
                props.navigateTo(props.navigateFrom);
              }}
              // disable={isSaveDisabled}
            />

            <PrimaryButton
              className="w-100"
              label="Save"
              clicked={() => {
                // setConfirmAlert({alert :true, message : });
                startBuildingVenue();
              }}
              disable={isSaveDisabled}
            />
          </div>
        </div>
      </div>

      <Spinner show={loading} />

      <ConfirmAlert
        message={confirmAlert.message}
        primaryText={'Yes'}
        secondaryText={'No'}
        secondaryAction={() => {
          setConfirmAlert({ alert: false, message: '' });
          setAssetsInBuilding([]);
        }}
        visible={confirmAlert.alert}
        title={'Finish Building Creation'}
        primaryAction={() => {
          setConfirmAlert({ alert: false, message: '' });
          createBuilding();
        }}
        onClose={() => {
          setConfirmAlert({ alert: false, message: '' });
          setAssetsInBuilding([]);
        }}
      />

      <ErrorAlert
        show={error.alert}
        onDismiss={() => {
          setError({ message: '', alert: false });
        }}
        message={error.message}
      />
      <SuccessAlert
        show={success.alert}
        onDismiss={() => {
          setSuccess({ message: '', alert: false });
        }}
        message={success.message}
      />
      <WarningAlert
        show={warning.alert}
        onDismiss={() => {
          setWarning({ message: '', alert: false });
        }}
        message={warning.message}
      />
    </div>
  );
};
